import { render, staticRenderFns } from "./ledScreenConfigForm.vue?vue&type=template&id=6eb3aed3&scoped=true&"
import script from "./ledScreenConfigForm.vue?vue&type=script&lang=js&"
export * from "./ledScreenConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./ledScreenConfigForm.vue?vue&type=style&index=0&id=6eb3aed3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb3aed3",
  null
  
)

export default component.exports